import React from "react";
import { string } from "prop-types";

const FooterLogo = ({ width = "155", height = "120" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 200 27" width={width} height={height}>
    <g>
      <g>
        <path
          fill="#231F20"
          d="M34.179,11.241l0.24,1.569c0.448-0.539,1.068-0.978,1.859-1.327c0.792-0.348,1.591-0.523,2.406-0.523
			c2.466,0,3.699,1.914,3.699,5.744c0,2.061-0.333,3.501-0.99,4.322c-0.659,0.819-1.694,1.23-3.102,1.23
			c-1.45,0-2.648-0.35-3.59-1.045c0.07,0.742,0.093,1.51,0.066,2.308v2.588h-3.198V11.241H34.179z M34.767,14.507v4.918
			c1.133,0.29,1.945,0.434,2.436,0.434c0.712,0,1.201-0.2,1.47-0.609c0.27-0.404,0.402-1.255,0.402-2.547
			c0-1.261-0.122-2.115-0.37-2.558c-0.246-0.44-0.681-0.663-1.302-0.663C36.69,13.483,35.812,13.824,34.767,14.507z"
        />
        <path
          fill="#231F20"
          d="M52.33,10.936l-0.327,2.982h-0.868c-0.712,0-1.806,0.248-3.288,0.74v7.312h-3.22v-10.73h2.501l0.284,1.569
			c1.464-1.25,2.918-1.874,4.353-1.874H52.33z"
        />
        <path
          fill="#231F20"
          d="M58.795,10.936c2.001,0,3.419,0.434,4.252,1.295c0.836,0.863,1.253,2.327,1.253,4.385
			c0,2.063-0.418,3.515-1.253,4.365c-0.832,0.849-2.251,1.274-4.252,1.274c-2.017,0-3.444-0.425-4.279-1.274
			c-0.833-0.85-1.249-2.302-1.249-4.365c0-2.073,0.416-3.538,1.249-4.398C55.351,11.364,56.778,10.936,58.795,10.936z
			 M58.795,13.351c-0.857,0-1.429,0.22-1.72,0.654c-0.292,0.435-0.436,1.308-0.436,2.612c0,1.278,0.144,2.134,0.436,2.569
			c0.291,0.436,0.863,0.654,1.72,0.654c0.824,0,1.387-0.218,1.685-0.654c0.296-0.435,0.447-1.291,0.447-2.569
			c0-1.291-0.146-2.158-0.434-2.598C60.201,13.574,59.636,13.351,58.795,13.351z"
        />
        <path
          fill="#231F20"
          d="M70.634,13.396v5.069c0,0.411,0.086,0.692,0.259,0.851c0.177,0.16,0.479,0.239,0.916,0.239h1.372l0.345,2.242
			c-0.824,0.291-1.833,0.435-3.027,0.435c-0.969,0-1.726-0.272-2.26-0.815c-0.538-0.546-0.806-1.303-0.806-2.276v-5.745h-1.895
			v-2.046l1.895-0.11V8.239h3.2v3.002h2.98v2.156H70.634z"
        />
        <path
          fill="#231F20"
          d="M78.643,6.737v3.72c0,0.741-0.068,1.489-0.198,2.242c1.496-1.174,2.962-1.763,4.398-1.763
			c0.972,0,1.715,0.255,2.23,0.763c0.516,0.507,0.772,1.247,0.772,2.219v8.053h-3.2V14.92c0-0.481-0.076-0.809-0.227-0.99
			c-0.153-0.181-0.422-0.273-0.818-0.273c-0.766,0-1.762,0.327-2.98,0.979v7.335h-3.22V6.737H78.643z"
        />
        <path
          fill="#231F20"
          d="M93.506,10.936c2.002,0,3.423,0.434,4.258,1.295c0.831,0.863,1.25,2.327,1.25,4.385
			c0,2.063-0.419,3.515-1.25,4.365c-0.836,0.849-2.257,1.274-4.258,1.274c-2.014,0-3.441-0.425-4.274-1.274
			c-0.834-0.85-1.252-2.302-1.252-4.365c0-2.073,0.418-3.538,1.252-4.398C90.065,11.364,91.492,10.936,93.506,10.936z
			 M93.506,13.351c-0.855,0-1.426,0.22-1.718,0.654c-0.292,0.435-0.438,1.308-0.438,2.612c0,1.278,0.146,2.134,0.438,2.569
			c0.292,0.436,0.863,0.654,1.718,0.654c0.829,0,1.39-0.218,1.688-0.654c0.297-0.435,0.447-1.291,0.447-2.569
			c0-1.291-0.146-2.158-0.436-2.598C94.913,13.574,94.347,13.351,93.506,13.351z"
        />
        <path
          fill="#231F20"
          d="M103.78,11.241l0.218,1.569c1.36-1.25,2.728-1.874,4.09-1.874c1.453,0,2.372,0.581,2.766,1.741
			c1.261-1.16,2.566-1.741,3.915-1.741c0.974,0,1.714,0.255,2.221,0.763c0.508,0.507,0.762,1.247,0.762,2.219v8.053h-3.199V14.92
			c0-0.465-0.082-0.792-0.24-0.979c-0.16-0.189-0.46-0.284-0.894-0.284c-0.347,0-0.679,0.067-0.999,0.197
			c-0.32,0.13-0.785,0.385-1.394,0.762v7.355h-3.089V14.92c0-0.465-0.092-0.792-0.272-0.979c-0.183-0.189-0.477-0.284-0.883-0.284
			c-0.566,0-1.358,0.313-2.373,0.937v7.378h-3.198v-10.73H103.78z"
        />
        <path
          fill="#231F20"
          d="M121.499,13.636l-0.308-2.177c1.933-0.348,3.795-0.523,5.594-0.523c1.451,0,2.519,0.294,3.199,0.883
			c0.684,0.588,1.025,1.608,1.025,3.058v7.093h-2.548l-0.326-1.632c-1.076,1.264-2.394,1.893-3.963,1.893
			c-1.029,0-1.869-0.272-2.524-0.815c-0.654-0.546-0.978-1.303-0.978-2.276v-1.087c0-0.856,0.288-1.524,0.87-2.003
			c0.577-0.478,1.388-0.719,2.415-0.719h3.83v-0.479c-0.011-0.55-0.138-0.922-0.381-1.109c-0.237-0.188-0.701-0.283-1.381-0.283
			C124.835,13.462,123.328,13.52,121.499,13.636z M123.849,18.295v0.412c0,0.741,0.421,1.111,1.262,1.111
			c0.871,0,1.763-0.35,2.675-1.045v-1.501h-2.895C124.195,17.285,123.849,17.626,123.849,18.295z"
        />
        <path
          fill="#231F20"
          d="M136.776,6.737v11.729c0,0.727,0.407,1.09,1.218,1.09h0.871l0.37,2.242c-0.549,0.291-1.405,0.435-2.568,0.435
			c-0.955,0-1.71-0.258-2.266-0.77c-0.549-0.516-0.825-1.248-0.825-2.19V6.737H136.776z"
        />
        <path
          fill="#231F20"
          d="M145.742,10.936c2.004,0,3.424,0.434,4.257,1.295c0.833,0.863,1.251,2.327,1.251,4.385
			c0,2.063-0.418,3.515-1.251,4.365c-0.833,0.849-2.253,1.274-4.257,1.274c-2.018,0-3.439-0.425-4.277-1.274
			c-0.833-0.85-1.251-2.302-1.251-4.365c0-2.073,0.418-3.538,1.251-4.398C142.303,11.364,143.724,10.936,145.742,10.936z
			 M145.742,13.351c-0.854,0-1.428,0.22-1.719,0.654c-0.29,0.435-0.436,1.308-0.436,2.612c0,1.278,0.146,2.134,0.436,2.569
			c0.291,0.436,0.865,0.654,1.719,0.654c0.826,0,1.389-0.218,1.688-0.654c0.299-0.435,0.445-1.291,0.445-2.569
			c0-1.291-0.145-2.158-0.434-2.598C147.149,13.574,146.582,13.351,145.742,13.351z"
        />
        <path
          fill="#231F20"
          d="M154.362,18.685h0.873c0.418,0,0.71,0.079,0.88,0.239c0.166,0.161,0.249,0.449,0.249,0.871v1.044
			c0,0.421-0.083,0.716-0.249,0.883c-0.17,0.167-0.462,0.249-0.88,0.249h-0.873c-0.42,0-0.715-0.083-0.884-0.249
			c-0.165-0.167-0.25-0.462-0.25-0.883v-1.044c0-0.421,0.085-0.71,0.25-0.871C153.647,18.764,153.941,18.685,154.362,18.685z"
        />
        <path
          fill="#231F20"
          d="M167.594,19.426l0.281,2.089c-1.099,0.48-2.485,0.718-4.154,0.718c-1.974,0-3.363-0.425-4.169-1.272
			c-0.805-0.851-1.206-2.305-1.206-4.365c0-2.074,0.403-3.537,1.216-4.386c0.813-0.848,2.214-1.274,4.202-1.274
			c1.626,0,2.947,0.226,3.961,0.677l-0.348,2.002c-1.568-0.029-2.592-0.044-3.07-0.044c-0.986,0-1.665,0.211-2.035,0.629
			c-0.368,0.422-0.555,1.221-0.555,2.396c0,1.177,0.187,1.974,0.555,2.392c0.369,0.422,1.048,0.633,2.035,0.633
			C165.569,19.622,166.663,19.556,167.594,19.426z"
        />
        <path
          fill="#231F20"
          d="M174.754,10.936c2.002,0,3.421,0.434,4.256,1.295c0.836,0.863,1.251,2.327,1.251,4.385
			c0,2.063-0.415,3.515-1.251,4.365c-0.836,0.849-2.254,1.274-4.256,1.274c-2.017,0-3.443-0.425-4.276-1.274
			c-0.833-0.85-1.251-2.302-1.251-4.365c0-2.073,0.418-3.538,1.251-4.398C171.311,11.364,172.737,10.936,174.754,10.936z
			 M174.754,13.351c-0.856,0-1.43,0.22-1.722,0.654c-0.288,0.435-0.431,1.308-0.431,2.612c0,1.278,0.144,2.134,0.431,2.569
			c0.292,0.436,0.866,0.654,1.722,0.654c0.825,0,1.393-0.218,1.687-0.654c0.298-0.435,0.444-1.291,0.444-2.569
			c0-1.291-0.143-2.158-0.434-2.598C176.161,13.574,175.595,13.351,174.754,13.351z"
        />
        <path
          fill="#231F20"
          d="M185.026,11.241l0.217,1.569c1.365-1.25,2.727-1.874,4.093-1.874c1.449,0,2.372,0.581,2.765,1.741
			c1.26-1.16,2.567-1.741,3.917-1.741c0.974,0,1.711,0.255,2.219,0.763c0.511,0.507,0.763,1.247,0.763,2.219v8.053h-3.199V14.92
			c0-0.465-0.084-0.792-0.243-0.979c-0.157-0.189-0.453-0.284-0.89-0.284c-0.349,0-0.683,0.067-1.002,0.197
			c-0.318,0.13-0.782,0.385-1.392,0.762v7.355h-3.092V14.92c0-0.465-0.091-0.792-0.272-0.979c-0.18-0.189-0.475-0.284-0.88-0.284
			c-0.564,0-1.355,0.313-2.373,0.937v7.378h-3.2v-10.73H185.026z"
        />
        <g>
          <path
            fill="#E82329"
            d="M14.369,26.02c5.276,0,9.552-4.278,9.552-9.549c0-5.276-4.275-9.554-9.552-9.554
				c-5.272,0-9.548,4.278-9.548,9.554C4.821,21.742,9.098,26.02,14.369,26.02z"
          />
          <g>
            <rect x="13.882" y="0.894" fill="#E82329" width="0.973" height="4.753" />
          </g>
          <g>
            <rect
              x="18.597"
              y="4.522"
              transform="matrix(0.4845 -0.8748 0.8748 0.4845 6.4388 20.9421)"
              fill="#E82329"
              width="4.783"
              height="0.972"
            />
          </g>
          <g>
            <rect
              x="23.224"
              y="9.31"
              transform="matrix(0.8516 -0.5242 0.5242 0.8516 -1.3358 14.8743)"
              fill="#E82329"
              width="4.754"
              height="0.973"
            />
          </g>
          <g>
            <rect
              x="7.405"
              y="2.583"
              transform="matrix(0.8731 -0.4876 0.4876 0.8731 -1.413 4.4765)"
              fill="#E82329"
              width="0.974"
              height="4.74"
            />
          </g>
          <g>
            <polygon fill="#E82329" points="5.052,11.335 1,8.922 1.499,8.087 5.553,10.501 				" />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

FooterLogo.propTypes = {
  width: string,
  height: string
};

export default FooterLogo;
